const readBooleanEnv = (value?: string) => {
  if (!value) return false;

  return value.toLowerCase() === "true" || value === "1";
};

export const env = {
  REACT_APP_MODE:
    process.env.REACT_APP_MODE?.toLowerCase() === "production"
      ? "production"
      : "development",
  REACT_APP_EMULATOR_MODE: readBooleanEnv(process.env.REACT_APP_EMULATOR_MODE),

  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "",
  REACT_APP_API_FIREBASE_API_KEY: process.env.REACT_APP_API_FIREBASE_API_KEY || "",
  REACT_APP_API_FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_API_FIREBASE_AUTH_DOMAIN || "",
  REACT_APP_API_FIREBASE_PROJECT_ID: process.env.REACT_APP_API_FIREBASE_PROJECT_ID || "",
  REACT_APP_API_FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_API_FIREBASE_STORAGE_BUCKET || "",
  REACT_APP_API_FIREBASE_MESSAGE_SENDER_ID: process.env.REACT_APP_API_FIREBASE_MESSAGE_SENDER_ID || "",
  REACT_APP_API_FIREBASE_APP_ID: process.env.REACT_APP_API_FIREBASE_APP_ID || "",
  REACT_APP_API_FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_API_FIREBASE_MEASUREMENT_ID || "",
};

console.info("[env] emulator mode:", env.REACT_APP_EMULATOR_MODE);
